import { render, staticRenderFns } from "./SpBalanceOutstanding.vue?vue&type=template&id=56270662"
import script from "./SpBalanceOutstanding.vue?vue&type=script&lang=js"
export * from "./SpBalanceOutstanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports